import React, { FC, useState } from 'react';
import { UserFilters } from '../../../types/UserFilters';
import { useGetApplicationUsersReport } from '../../../api/queries/useGetApplicationUsersReport';
import { Sorting } from '../../../types/Sorting';
import { DEFAULT_SORT_DIRECTION, DEFAULT_SORT_FIELD } from '../applications/consts';
import { useGetUsersOfApplication } from '../../../api/queries/useGetUsersOfApplication';
import { UsersView } from '../users/UsersView';
import { UsersViewRenderMode } from '../users/UsersViewRenderMode';

type ApplicationUsersViewProps = {
    applicationId: string;
};

export const ApplicationUsersView: FC<ApplicationUsersViewProps> = ({ applicationId }) => {
    const [filters, setFilters] = useState<UserFilters>({});
    const [sorting, setSorting] = useState<Sorting>({
        direction: DEFAULT_SORT_DIRECTION,
        field: DEFAULT_SORT_FIELD
    });

    const { downloadReport, downloadingReport } = useGetApplicationUsersReport(applicationId, filters);
    const { fetchMoreUsers, users, usersLoading } = useGetUsersOfApplication(applicationId, filters, sorting);

    return (
        <UsersView
            downloadReport={downloadReport}
            downloading={downloadingReport}
            fetchMore={fetchMoreUsers}
            loading={usersLoading}
            renderMode={UsersViewRenderMode.ADVANCED}
            setFilters={setFilters}
            setSorting={setSorting}
            users={users}
        />
    );
};
